<template>
  <div class="item galeria">
    <div class="top flex flex-col xl:flex-row !h-fit">
      <div>
        <div class="icon"></div>
        <div class="title"><span>Galeria</span></div>
      </div>
      <div class="actions flex flex-row ml-auto mt-2">
        <button :disabled='disableP' @click="getArt(prev)"><i class="fa-solid fa-angle-left"></i></button>
        <button :disabled='disableN' @click="getArt(next)"><i class="fa-solid fa-angle-right"></i></button>
        <input type="text" name="search" placeholder="Pesquisar" v-model="search" @change.prevent="getArt()">
        <button><i class="fa-solid fa-magnifying-glass"></i></button>
      </div>
    </div>
    <div class="content grid grid-cols-1 xl:grid-cols-3 gap-4">
      <template v-if="loading">
        <Sk v-for="i in 3" :key="i" w="100%" h="264px" rounded="rounded-xl" />
      </template>
      <div class="box animate__animated animate__headShake w-full" v-else v-for="a in art" :key="a.id"
           :style="{backgroundImage: 'url('+a.imagem+')'}">
        <RouterLink :to="{path: `/arte`, name: 'Arte', params: {id: a.id, url: a.url}}">
          <div class="data">
            <div class="info">
              <div class="title nobr">{{ a.titulo }}</div>
              <div class="autor nobr">{{ a.autor }}</div>
              <div class="avatar"
                   :style="{backgroundImage: `url('${avatarUrl(a.autor, { direction: 4, head_direction: 3, headonly: 0 })}')`}"></div>
            </div>
          </div>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>

import { getArts, avatarUrl } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'
import { onMounted, ref } from 'vue'

const art = ref([])
const loading = ref(true)
const prev = ref(0)
const next = ref(0)
const disableN = ref(false)
const disableP = ref(false)
const search = ref('')

async function getArt(paga = 1) {
  loading.value = true
  try {
    const data = await getArts({ pag: paga, s: search.value })
    art.value  = data.art ?? []
    prev.value = data.prev ?? 0
    next.value = data.next ?? 0
    disableP.value = parseInt(data.prev) === 0
    disableN.value = data.next === 0
  } catch {
    art.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => getArt())

</script>

<style scoped>
/*noinspection ALL*/
.galeria {
  width: 100%;
  position: relative;
  height: fit-content;
  padding: 10px;
  background-color: var(--color2);
  @apply rounded-xl xl:rounded-none xl:rounded-l-xl
}

/*noinspection ALL*/
.galeria::after {
  content: '';
  width: 100%;
  height: 100%;
  left: 100%;
  top: 0;
  position: absolute;
  @apply xl:bg-[var(--color2)];
}

.galeria .top .icon {
  background-position: -32px -28px;
  background-color: #21415C;
}

.galeria .top .title {
  color: #fff;
}

.galeria .content {
  width: 100%;
  height: auto;
  position: relative;
  justify-content: space-between;
}

.galeria .content .box {
  height: 264px;
  border-radius: 12px;
  background-position: center;
  background-size: cover;
}

.galeria .box .data {
  position: relative;
  top: 50%;
  width: 100%;
  height: 50%;
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, .5) 100%);
  border-radius: 0 0 12px 12px;
  transition: all .3s ease;
}

.galeria .box:hover .data {
  background: rgba(0, 0, 0, .5);
  border-radius: 12px;
  top: 0;
  height: 100%;
}

.galeria .box .data .info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.galeria .box .data .info .title {
  position: absolute;
  width: calc(100% - 70px);
  height: 24px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  top: -26px;
  left: 10px;
}

.galeria .box .data .info .autor {
  position: absolute;
  left: 0;
  top: 0;
  width: auto;
  max-width: 85%;
  height: 24px;
  border-radius: 6px;
  line-height: 24px;
  padding: 0 6px;
  color: #fff;
  font-size: 12px;
  margin: 4px 0 10px 10px;
  background-color: #CA70A3;
}

.galeria .box .data .info .avatar {
  float: right;
  width: 56px;
  height: 100px;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: -62px;
}
</style>
